module.exports = __webpack_public_path__ + "img/2.1535e9af.png";